<template>
  <v-overlay :value="loading">
    <div id="text" class="d-inline">
      <p class="text-h5 text-center">Retrieving {{ type }} Data...</p>
    </div>
    <div id="progress-circular" class="d-inline">
      <v-progress-circular id="progress" indeterminate size="45" class="mx-auto d-block">
      </v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'Unknown_Data',
    },
  },
};
</script>
